import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import CollapsibleCollection, {InjectedParentFieldProps} from './Collection';

export interface CollapsibleFieldProps {
    field: any;
    depth?: number;
    renderParent(props: InjectedParentFieldProps): JSX.Element;
    renderChild(props: InjectedCollapsibleFieldProps): JSX.Element;
}

export interface InjectedCollapsibleFieldProps extends CollapsibleFieldProps {
    depth: number;
}

@observer
export default class CollapsibleField extends Component<CollapsibleFieldProps, null> {
    render() {
        const {field, renderChild: ChildField, depth = 0} = this.props;
        if (field.collection && field.collection.hasChildren) {
            return <CollapsibleCollection {...this.props} />;
        }
        return <ChildField {...this.props} depth={depth} />;
    }
}
